import { render, staticRenderFns } from "./SmallTeamBanner.vue?vue&type=template&id=02d4285d&"
import script from "./SmallTeamBanner.vue?vue&type=script&lang=js&"
export * from "./SmallTeamBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports